<template>
    <v-dialog
        v-model       = "show"
        :max-width    = "400"
        persistent
        hide-overlay
        content-class = "dialog-border"
    >
        <div class="white preview-panel">
            <div class="close-button">
                <c-toolbar-button
                    size     = "28"
                    color    = "red"
                    icon     = "mdi-close"
                    :tooltip = "$t('common.cancel')"
                    @click   = "onCancel"
                />
            </div>

            <img
                v-if  = "image"
                :src  = "image"
                alt   = ""
                class = "preview-image"
            />
        </div>
    </v-dialog>
</template>

<script>
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

export default {
    name: "FImagePreview",

    components: {
        CToolbarButton
    },

    props: {
        value: {

        },

        image: {

        }
    },

    data: () => ({
        show: false
    }),

    mounted() {
        this.show = this.value;
    },

    watch: {
        value () {
            this.show = this.value;
        }
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        }
    }
}
</script>

<style scoped>

.preview-image {
    max-width:100%;
    height:auto
}

.preview-panel {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    position: relative;
}

.close-button {
    position: absolute;
    z-index: 11;
    right: 14px;
    top: 10px;
}

</style>